import {
  AfterViewInit,
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter,
  inject,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { RightBridgeApiService } from '../../services/right-bridge-api.service';
import { UnifiedFlowService } from '../unified.service';
import { ConsolidatedReportModalComponent } from '../../shared-components/consolidated-report-modal/consolidated-report-modal.component';
import { CustomReportModalComponent } from '../../shared-components/custom-report-modal/custom-report-modal.component';
import { WarnDialogComponent } from '../../warn-dialog/warn-dialog.component';
import { LoadingDialogComponent } from '../../loading-dialog/loading-dialog.component';
import { AnnuityWizardService } from '../../annuity-wizard/services/annuity-wizard-service.service';
import { InvestmentWizardService } from '../../investment-wizard/services/investment-wizard-service.service';
import { LifeWizardService } from '../../services/life-wizard.service';
import { Platform } from '@angular/cdk/platform';
import { saveAs } from '@progress/kendo-file-saver';
import { EnvironmentService } from '../../services/environment.service';
import { CaseManagementService } from '../../case-management/case-management.service';
import { SessionStorageService } from '../../services/session-storage.service';
import { NetworkLoadingModalComponent } from '../../network-loading-modal/network-loading-modal.component';
import { Global } from '../../models/global.model';
import { ConnectorMessage } from '../../models/network-models';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ModuleStatusService } from '../../services/module-status.service';
import { CopyCaseModalComponent } from '../copy-case-modal/copy-case-modal.component';
import { PostTradeService } from '../../post-trade/post-trade.service';
import { forkJoin, Observable, of } from 'rxjs';
import { NgxLoadingModule } from 'ngx-loading';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { AiSummaryComponent } from '../../ai-summary/ai-summary.component';
import { MatTooltipModule } from '@angular/material/tooltip';

declare let callGlue: (param1: string, param2: number) => void;
@Component({
  selector: 'app-unified-summary-page',
  templateUrl: './unified-summary-page.component.html',
  styleUrls: ['./unified-summary-page.component.scss'],
  imports: [
    NgxLoadingModule,
    MatButtonModule,
    MatIconModule,
    CommonModule,
    AiSummaryComponent,
    MatTooltipModule,
  ],
})
export class UnifiedSummaryPageComponent implements AfterViewInit, OnInit {
  private unfFlowSvc = inject(UnifiedFlowService);
  private route = inject(ActivatedRoute);
  private rbs = inject(RightBridgeApiService);
  private router = inject(Router);
  private dialog = inject(MatDialog);
  private aws = inject(AnnuityWizardService);
  private iws = inject(InvestmentWizardService);
  private lws = inject(LifeWizardService);
  private pltfrm = inject(Platform);
  private envSvc = inject(EnvironmentService);
  private cmsSvc = inject(CaseManagementService);
  private ss = inject(SessionStorageService);
  private snacky = inject(MatSnackBar);
  modStatusSvc = inject(ModuleStatusService);
  private postTradeService = inject(PostTradeService);

  @ViewChild('samlForm') samlForm: ElementRef;
  @Output() navigateTo = new EventEmitter();
  @Output() summaryClient = new EventEmitter();
  @Output() aiSummaryChecked = new EventEmitter();

  aiSummaryTool = false;
  apiData;
  applications = [];
  baseUrl;
  buttonInstructions;
  buttons;
  currentApp;
  currentStep;
  disableCreateCm = false;
  environment;
  existingOrderId;
  globals: Global;
  networkModalData: ConnectorMessage;
  printDefaults;
  profile;
  profileCRID;
  rights: string[];
  submitting = false;
  showPrint = {
    pp: {
      show: false,
      disable: false,
      text: 'Submit',
    },
    aw1: {
      show: false,
      disable: false,
      text: 'Submit',
    },
    aw2: {
      show: false,
      disable: false,
      text: 'Submit',
    },
    aw3: {
      show: false,
      disable: false,
      text: 'Submit',
    },
    iw: {
      show: false,
      disable: false,
      text: 'Submit',
    },
    li: {
      show: false,
      disable: false,
      text: 'Submit',
    },
  };
  loading = false;

  numPositiveScores = 0;
  numNeutralScores = 0;
  numNegativeScores = 0;
  navAfterGeneration;
  showCopyCase = false;
  org: string;
  aiSummaryData: {
    AICaseSummaryCheckBoxText: string;
    AICaseSummaryDisclosure: string;
    AICaseSummaryEditable: boolean;
    AICaseSummaryLabel: string;
    AICaseSummaryPlaceholder: string;
    AICaseSummaryPrompt: string;
    AICaseSummaryPromptName: string;
    AICaseSummaryGroup: string;
    AINoteConfigurationID: string;
    AWDocumentReadingAIPromptID: string;
    IWDocumentReadingAIPromptID: string;
    IncludeDocumentReadingAW: boolean;
    IncludeDocumentReadingIW: boolean;
    IncludeDocumentReadingPP: boolean;
    MaxSubmissions: number;
    PPDocumentReadingAIPromptID: string;
    ShowAICaseSummary: boolean;
    testExtraVar: boolean;
  };
  aiSummaryText: string;
  aiSummaryEdit: boolean;
  lastInteraction: string;
  aiSummaryReadOnly: string;
  aiSummaryCheckedVar = false;
  mostRecentSummarySearchResult;
  summaryLoading: boolean;
  instructionText: string;
  stayInPlan: boolean;

  ngOnInit(): void {
    this.org = this.rbs.getOrg();
    this.environment = this.envSvc.get();
    this.baseUrl = this.environment.apiBase;
    this.rights = this.ss.get('rights');

    this.route.params.subscribe(params => {
      this.profile = params.id;
      this.currentApp = params.app ? params.app : 'rb';
      this.currentStep = params.step ? params.step : this.currentStep;
    });
    this.globals = this.ss.get('globals');
    if (this.globals) {
      this.networkModalData = this.globals.GlobalsGroup.UnitAPI.ConnectorMessage
        ? JSON.parse(this.globals.GlobalsGroup.UnitAPI.ConnectorMessage)[
            'ConnectorMessage'
          ]
        : { body: null, messageDelay: null, messages: null, title: null };

      this.showCopyCase =
        this.globals.GlobalsGroup?.['UnitCopySettings']?.CopyOnCaseSummaryPage;
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.getSummaryData(this.profile);
    }, 500);
  }

  getSummaryData(profile) {
    const save = this.unfFlowSvc.getSaving();
    if (save) {
      setTimeout(() => {
        this.getSummaryData(this.profile);
      }, 250);
    } else {
      this.unfFlowSvc.setLoading(true);
      this.unfFlowSvc.summaryData(profile).subscribe(x => {
        this.setSummaryClient(x);
        this.apiData = x;
        this.applications = x.Modules;
        this.applications.forEach(app => {
          app['expanded'] = app.vars.GeneralSettings
            ? app.vars.GeneralSettings.Expanded
            : false;
          switch (app.name.toLowerCase()) {
            case 'pp':
              this.showPrint.pp.show =
                app.vars.ButtonSettings.PPPrintButtonShow;
              this.showPrint.pp.disable =
                !app.vars.ButtonSettings.PPPrintButtonActive;
              this.showPrint.pp.text =
                app.vars.ButtonSettings.PPPrintButtonText;
              break;
            case 'aw':
              this.showPrint.aw1.show =
                app.vars.ButtonSettings.AW1PrintButtonShow;
              this.showPrint.aw1.disable =
                !app.vars.ButtonSettings.AW1PrintButtonActive;
              this.showPrint.aw1.text =
                app.vars.ButtonSettings.AW1PrintButtonText;
              this.showPrint.aw2.show =
                app.vars.ButtonSettings.AW2PrintButtonShow;
              this.showPrint.aw2.disable =
                !app.vars.ButtonSettings.AW2PrintButtonActive;
              this.showPrint.aw2.text =
                app.vars.ButtonSettings.AW2PrintButtonText;
              this.showPrint.aw3.show =
                app.vars.ButtonSettings.AW3PrintButtonShow;
              this.showPrint.aw3.disable =
                !app.vars.ButtonSettings.AW3PrintButtonActive;
              this.showPrint.aw3.text =
                app.vars.ButtonSettings.AW3PrintButtonText;
              break;
            case 'iw':
              this.showPrint.iw.show =
                app.vars.ButtonSettings.IWPrintButtonShow;
              this.showPrint.iw.disable =
                !app.vars.ButtonSettings.IWPrintButtonActive;
              this.showPrint.iw.text =
                app.vars.ButtonSettings.IWPrintButtonText;
              break;
            case 'li':
              this.showPrint.li.show =
                app.vars.ButtonSettings.LWPrintButtonShow;
              this.showPrint.li.disable =
                !app.vars.ButtonSettings.LWPrintButtonActive;
              this.showPrint.li.text =
                app.vars.ButtonSettings.LWPrintButtonText;
              break;
          }
        });
        this.applications.forEach(app => {
          if (app.vars.ProductSelected?.length > 0) {
            app['numPositiveScores'] = 0;
            app['numNeutralScores'] = 0;
            app['numNegativeScores'] = 0;
            app.vars.ProductType.forEach(type => {
              app.vars[this.checkProductType(type.Type)]?.forEach(item => {
                if (
                  (this.checkProductType(type.Type) === 'ProductSelected' &&
                    item.Type.toLowerCase() === type.Type.toLowerCase()) ||
                  this.checkProductType(type.Type) !== 'ProductSelected'
                ) {
                  switch (item.ScoreClass) {
                    case 'positive':
                      app['numPositiveScores'] += 1;
                      break;
                    case 'neutral':
                      app['numNeutralScores'] += 1;
                      break;
                    case 'negative':
                      app['numNegativeScores'] += 1;
                      break;

                    default:
                      break;
                  }
                }
              });
            });
          }
        });
        this.buttons = x.Modules.find(
          z => z.name === 'Actions'
        ).vars.ButtonSettings;
        this.buttonInstructions = x.Modules.find(
          z => z.name === 'Actions'
        ).vars.GeneralSettings;
        if (this.buttonInstructions.ShowInstructionText) {
          this.instructionText = this.parseInstructionText(
            this.buttonInstructions.InstructionText
          );
        }
        this.printDefaults = x.UnitPrintDefaults;
        this.existingOrderId = x.AWProfilingResults.OrderEntryID;
        this.profileCRID = x.ClientProfilingOut.CRID;
        this.lastInteraction = x.Client.LastInteractionDate;
        this.aiSummaryData = x.UnitAISettings;
        this.aiSummaryEdit = this.aiSummaryData?.AICaseSummaryEditable;
        this.aiSummaryTool = this.aiSummaryData?.ShowAICaseSummary;
        this.aiSummaryReadOnly =
          x.ClientProfilingOut?.SubmitStatus === 'S' &&
          this.ss.get('rights').includes('locksubmittedcase');
        if (this.aiSummaryTool) {
          this.summaryLoading = true;
          this.aiSummaryData['SummaryValidated'] = x.AICaseSummary
            ?.SummaryValidated
            ? true
            : false;
          if (this.aiSummaryData['SummaryValidated']) {
            this.summaryCheck(this.aiSummaryData['SummaryValidated']);
          }
          this.aiSummaryData['LastInteraction'] = this.lastInteraction;
          this.aiSummaryData['profileId'] = this.profile;
        }
        this.stayInPlan =
          x.ClientProfiling &&
          Object.prototype.hasOwnProperty.call(
            x.ClientProfiling,
            'StayInPlan'
          ) &&
          x.ClientProfiling.StayInPlan;
        this.unfFlowSvc.setLoading(false);
      });
    }
  }

  checkProductType(productType) {
    const productSelectedList = [
      'Accumulation',
      'DeathBenefit',
      'IWResult',
      'IWPortfolio',
      'Product',
      'Rollover',
      'Exchange',
      'Income',
      'LifeProduct',
    ];

    if (productSelectedList.includes(productType)) {
      return 'ProductSelected';
    }

    return productType;
  }

  filterProductSelected(products: any[]): any[] {
    return products.filter(prod => prod.Type === 'product');
  }

  toggleExpand(event, index) {
    this.applications[index]['expanded'] =
      !this.applications[index]['expanded'];
  }

  completeCase(app) {
    this.navigateTo.emit({ app: app, profile: this.profile, step: 0 });
  }

  editInfo(app) {
    this.navigateTo.emit({ app: app, profile: this.profile, step: 0 });
  }

  viewResults(app) {
    if (app === 'aw' || app === 'pp') {
      this.router.navigate([`/case/${app}/${this.profile}/results`]);
    } else if (app === 'iw') {
      this.router.navigate([`/case/${app}/${this.profile}/validate`]);
    } else if (app === 'li') {
      if (this.apiData['LifeWizard'].AssessmentType === 1) {
        this.router.navigate([`/case/${app}/${this.profile}/products`]);
      } else {
        this.router.navigate([`/case/${app}/${this.profile}/validate`]);
      }
    }
  }

  consolidatedReport() {
    const status = { aw: null, pp: null, li: null, iw: null };

    this.applications.forEach(app => {
      status[app.name.toLowerCase()] = app.vars.ModuleStatus.FlowStatus === 'C';
    });

    let consolidatedDialog = this.dialog.open(
      ConsolidatedReportModalComponent,
      {
        panelClass: 'consolidated-report',
        data: { profile: this.profile, appStatus: status },
        minWidth: '80vw',
        minHeight: '95vh',
        maxHeight: '95vh',
      }
    );
    consolidatedDialog.afterClosed().subscribe(() => {
      consolidatedDialog = null;
    });
  }

  getReport(ev, app, type?, silent = false) {
    this.rbs.setApp(app);

    if (!silent) {
      this.unfFlowSvc.setLoading(true);
    }
    const iosSafari =
      this.pltfrm.IOS ||
      (navigator?.['userAgentData']?.platform === 'macOS' &&
        navigator.maxTouchPoints > 1);

    if (app === 'aw') {
      if (type === 'exchange') {
        const iosSafari =
          this.pltfrm.IOS ||
          (navigator?.['userAgentData']?.platform === 'macOS' &&
            navigator.maxTouchPoints > 1);

        this.rbs
          .getExchangeReport(this.profile, null, silent)
          .subscribe(data => {
            if (!silent) {
              const date = new Date();
              const filename =
                'AnnuityWizard-' +
                (date.getMonth() + 1) +
                date.getDate() +
                date.getFullYear() +
                '.pdf';

              let fileData;
              const reader = new FileReader();
              reader.readAsDataURL(data);
              reader.onloadend = () => {
                fileData = reader.result;
                saveAs(fileData, filename, {
                  proxyURL: `${this.baseUrl}/util/proxy`,
                  proxyTarget: '_self',
                  forceProxy: iosSafari,
                });
              };
            }
            this.unfFlowSvc.setLoading(false);
          });
      } else {
        this.aws
          .getReport(
            this.profile,
            null,
            silent,
            this.printDefaults.AWIncludeVAInvestmentOptions,
            type && type === 'awClient',
            this.printDefaults.AWExcludeAlternatives
          )
          .subscribe(data => {
            if (!silent) {
              const date = new Date();
              const filename =
                'AnnuityWizard-' +
                (date.getMonth() + 1) +
                date.getDate() +
                date.getFullYear() +
                '.pdf';

              let fileData;
              const reader = new FileReader();
              reader.readAsDataURL(data);
              reader.onloadend = () => {
                fileData = reader.result;
                saveAs(fileData, filename, {
                  proxyURL: `${this.baseUrl}/util/proxy`,
                  proxyTarget: '_self',
                  forceProxy: iosSafari,
                });
              };
            }
            this.unfFlowSvc.setLoading(false);
          });
      }
    } else if (app === 'pp') {
      // includeDetail	UnitPrintDefaults.PPIncludeDetail
      // includeIW	Set in Consolidated Print Dialog box
      // includeAW	Set in Consolidated Print Dialog box
      // includeLI	Set in Consolidated Print Dialog box

      this.rbs
        .getReport(
          this.profile,
          this.printDefaults.PPIncludeDetail,
          silent,
          false,
          false
        )
        .subscribe(data => {
          if (!silent) {
            const date = new Date();
            const filename =
              'ProductProfiler-' +
              (date.getMonth() + 1) +
              date.getDate() +
              date.getFullYear() +
              '.pdf';

            const iosSafari =
              this.pltfrm.IOS ||
              (navigator?.['userAgentData']?.platform === 'macOS' &&
                navigator.maxTouchPoints > 1);

            let fileData;
            const reader = new FileReader();
            reader.readAsDataURL(data);
            reader.onloadend = () => {
              fileData = reader.result;
              saveAs(fileData, filename, {
                proxyURL: `${this.baseUrl}/util/proxy`,
                proxyTarget: '_self',
                forceProxy: iosSafari,
              });
            };
          }
          if (!this.submitting) {
            this.unfFlowSvc.setLoading(false);
          }
        });
    } else if (app === 'iw') {
      // includeDetail	UnitPrintDefaults.FundDetails
      // includeAlternatives	UnitPrintDefaults.ProgramDetails
      // includeFundAlternativesChart	UnitPrintDefaults.FundAlternatives
      this.iws
        .getReport(
          this.profile,
          this.printDefaults.IWFundDetails,
          this.printDefaults.IWProgramDetails,
          this.printDefaults.IWFundAlternatives,
          silent
        )
        .subscribe(data => {
          if (!silent) {
            const date = new Date();
            const filename =
              'InvestmentWizardReport-' +
              (date.getMonth() + 1) +
              date.getDate() +
              date.getFullYear() +
              '.pdf';

            let fileData;
            const reader = new FileReader();
            reader.readAsDataURL(data);
            reader.onloadend = () => {
              fileData = reader.result;
              saveAs(fileData, filename, {
                proxyURL: `${this.baseUrl}/util/proxy`,
                proxyTarget: '_self',
                forceProxy: iosSafari,
              });
            };
          }
          this.unfFlowSvc.setLoading(false);
        });
    } else if (app === 'li' || app === 'lw') {
      // includeDetail	UnitPrintDefaults.FundDetails
      // includeAlternatives	UnitPrintDefaults.ProgramDetails
      // includeFundAlternativesChart	UnitPrintDefaults.FundAlternatives

      const liModule = this.applications.find(
        x => x.name.toLowerCase() === 'li'
      );
      const prodList = liModule.vars.ProductSelected.map(x => x.BridgeID);
      const prods = { bridgeIds: prodList };

      this.lws.getReport(this.profile, prods, silent).subscribe(data => {
        if (!silent) {
          const date = new Date();
          const filename =
            'LifeWizard-' +
            (date.getMonth() + 1) +
            date.getDate() +
            date.getFullYear() +
            '.pdf';

          let fileData;
          const reader = new FileReader();
          reader.readAsDataURL(data);
          reader.onloadend = () => {
            fileData = reader.result;
            saveAs(fileData, filename, {
              proxyURL: `${this.baseUrl}/util/proxy`,
              proxyTarget: '_self',
              forceProxy: iosSafari,
            });
          };
        }
        this.unfFlowSvc.setLoading(false);
      });
    }
  }

  customReport(type?, silent?) {
    if (!silent) {
      this.unfFlowSvc.setLoading(true);
    }
    const customDefinition = { definition: null };
    customDefinition.definition = JSON.parse(this.buttons.CustomPrintModalName);
    const customDefinitionType = type
      ? type
      : customDefinition.definition.ReportType?.toLowerCase();

    const uptickRevisionDef = customDefinition.definition.UptickRevision;
    if (
      customDefinitionType === 'switch' ||
      customDefinitionType === 'mmreport' ||
      customDefinitionType === 'template'
    ) {
      let dialogRef;
      if (
        customDefinitionType === 'mmreport' ||
        customDefinitionType === 'template'
      ) {
        if (!silent) {
          this.unfFlowSvc.setLoading(false);
          dialogRef = this.dialog.open(LoadingDialogComponent, {
            panelClass: 'app-loading-dialog',
            data: {
              headline: 'Please wait',
              content: 'Your report is generating. This may take a moment...',
            },
            disableClose: true,
          });
        }
      }
      const payload = {
        ReportType: customDefinitionType,
        ProfileID: this.profile,
      };
      const solution =
        customDefinition.definition.Solution?.toLowerCase() || 'pp';
      if (uptickRevisionDef !== null || uptickRevisionDef !== undefined)
        payload['UptickRevision'] = uptickRevisionDef;
      if (customDefinitionType === 'template') {
        payload['UIConfig'] =
          customDefinition.definition.UIConfig.toLowerCase();
      }

      this.rbs.getCustomReport(payload, solution, silent).subscribe({
        next: data => {
          if (!silent) {
            const date = new Date();
            const filename =
              'RightBridge-Report-' +
              (date.getMonth() + 1) +
              date.getDate() +
              date.getFullYear() +
              '.pdf';

            const iosSafari =
              this.pltfrm.IOS ||
              (navigator?.['userAgentData']?.platform === 'macOS' &&
                navigator.maxTouchPoints > 1);

            let fileData;
            const reader = new FileReader();
            reader.readAsDataURL(data);
            reader.onloadend = () => {
              fileData = reader.result;
              saveAs(fileData, filename, {
                proxyURL: `${this.baseUrl}/util/proxy`,
                proxyTarget: '_self',
                forceProxy: iosSafari,
              });

              if (dialogRef) {
                dialogRef.componentInstance.headline = 'Complete!';
                dialogRef.componentInstance.content =
                  'Your report has been generated! Thank you for your patience.';
                dialogRef.componentInstance.endModal();
              }
              this.unfFlowSvc.setLoading(false);
            };
          }
          if (this.navAfterGeneration) {
            this.router.navigate([this.navAfterGeneration]);
          }
        },
        error: () => {
          if (dialogRef) {
            dialogRef.componentInstance.endModal(false);
          }
          dialogRef = this.dialog.open(WarnDialogComponent, {
            panelClass: 'warn-dialog',
            data: {
              headline: 'Error',
              content:
                'Your report could not be generated due to an unexpected error. Please try again. If this error persists, please contact your administrator.',
              confirm: 'OK',
              hideCancel: true,
            },
          });
          this.unfFlowSvc.setLoading(false);
        },
      });
    } else {
      this.unfFlowSvc.setLoading(false);
      let dialogRef = this.dialog.open(CustomReportModalComponent, {
        panelClass: 'custom-report',
        data: {
          name: 'custom',
          profile: this.profile,
          reportDef: customDefinition,
        },
        minWidth: '80vw',
        minHeight: '95vh',
        maxHeight: '95vh',
      });

      dialogRef.afterClosed().subscribe(() => {
        dialogRef = null;
      });
    }
  }

  submitCase(ev, app, appParams?, buttonNum?) {
    if (this.aiSummaryTool) {
      this.saveSummary();
    }
    this.submitting = true;
    const buttonSettings = appParams;
    const action = buttonNum
      ? appParams['ButtonAction' + buttonNum]
      : buttonSettings.ButtonAction;
    switch (action) {
      case 'R':
        this.redirect(buttonSettings, buttonNum);
        break;
      case 'P':
        this.postback(app, buttonSettings, buttonNum);
        break;
      case 'S':
        this.standardPostback(app, buttonSettings, buttonNum);
        break;
    }
  }

  submitCaseManagement(appSettings, buttonNum?) {
    this.disableCreateCm = true;
    this.loading = true;

    const silentPrintAw = !!appSettings['CMCreateAuditWithButtonAW1'],
      silentClientRpt = !!appSettings['CMCreateAuditWithButtonAW2'],
      silentXchng = !!appSettings['CMCreateAuditWithButtonAW3'],
      silentPrintPp = !!appSettings['CMCreateAuditWithButtonPP'],
      silentPrintIw = !!appSettings['CMCreateAuditWithButtonIW'],
      silentPrintLw = !!appSettings['CMCreateAuditWithButtonLW'],
      silentPrintSwitch = !!appSettings['CMCreateAuditWithButtonSwitch'],
      silentPrintTemplate = !!appSettings['CMCreateAuditWithButtonTemplate'];

    this.cmsSvc.processCaseManagementRecord(this.profile).subscribe({
      next: resp => {
        if (resp['result'] === 'Success') {
          this.runSilentPrints({
            aw: silentPrintAw,
            temp: silentPrintTemplate,
            awClient: silentClientRpt,
            exchange: silentXchng,
            pp: silentPrintPp,
            iw:
              silentPrintIw &&
              this.applications.find(app => app.name === 'IW')?.vars
                ?.ModuleStatus?.Status === 'C',
            lw: silentPrintLw,
            sw: silentPrintSwitch,
          }).subscribe(() => {
            this.router.navigate([`/case-conclusion`]);
          });
        } else if (resp['result'] && !isNaN(+resp['result'])) {
          this.profileCRID = resp['result'];
          this.navAfterGeneration = `/case-management/case-manager/${this.profileCRID}`;
          this.runSilentPrints({
            aw: silentPrintAw,
            sw: silentPrintSwitch,
            temp: silentPrintTemplate,
            awClient: silentClientRpt,
            exchange: silentXchng,
            pp: silentPrintPp,
            iw:
              silentPrintIw &&
              this.applications.find(app => app.name === 'IW')?.vars
                ?.ModuleStatus?.Status === 'C',
            lw: silentPrintLw,
          }).subscribe(() => {
            this.router.navigate([this.navAfterGeneration]);
          });
        } else {
          // 200 with error message
          this.loading = false;
          let dialogRef = this.dialog.open(WarnDialogComponent, {
            panelClass: 'warn-dialog',
            data: {
              headline: 'Error',
              content:
                'There was a error validating the data of this case. Please verify that all required pages of this case have valid data.',
              confirm: 'Okay',
            },
          });
          dialogRef.afterClosed().subscribe(() => {
            dialogRef = null;
          });
        }
      },
      error: () => {
        this.disableCreateCm = false;
        this.loading = false;
        this.snacky.open('There was an error with this request.', 'Close', {
          duration: 10000,
        });
      },
    });
  }

  launchCaseManagement() {
    this.router.navigate([`/case-management/case-manager/${this.profileCRID}`]);
  }

  loginRedirect(data) {
    const url = data.url || data.ssoUrl;

    this.samlForm.nativeElement.action = url;

    if (data.SAMLResponse) {
      this.samlForm.nativeElement['SAMLResponse'].value = data.SAMLResponse;
    } else {
      this.samlForm.nativeElement['Token'].value = data.token;
    }

    this.samlForm.nativeElement.submit();
  }

  redirect(appSettings?, buttonNum?) {
    this.loading = true;

    const num = buttonNum ? buttonNum : '',
      silentPrintAw = !!appSettings[`AuditWithButtonAW1${num}`],
      silentClientRpt = !!appSettings[`AuditWithButtonAW2${num}`],
      silentXchng = !!appSettings[`AuditWithButtonAW3${num}`],
      silentPrintPp = !!appSettings[`AuditWithButtonPP${num}`],
      silentPrintIw = !!appSettings[`AuditWithButtonIW${num}`],
      silentPrintLw = !!appSettings[`AuditWithButtonLW${num}`],
      silentPrintTemplate = !!appSettings[`AuditWithButtonTemplate${num}`],
      silentPrintSwitch = !!appSettings[`AuditWithButtonSwitch${num}`],
      customSolution = appSettings[`PostbackSolution${num}`],
      newTab = appSettings[`RedirectSameTab${num}`] ? '_self' : '_blank';
    let link = appSettings[`RedirectURL${num}`] || null;
    const outsideLink = link.includes('http');

    this.runSilentPrints({
      aw: silentPrintAw,
      temp: silentPrintTemplate,
      sw: silentPrintSwitch,
      awClient: silentClientRpt,
      exchange: silentXchng,
      pp: silentPrintPp,
      iw: silentPrintIw,
      lw: silentPrintLw,
    }).subscribe(() => {
      link = link.includes('complete') ? '/completed' : link;

      if (outsideLink) {
        window.open(link, newTab);
      } else {
        this.router.navigate([link]);
      }

      this.loading = false;
    });
  }

  postback(app, appSettings, buttonNum?, ignoreWarning = false) {
    const num = buttonNum ? buttonNum : '',
      silentPrintAw = !!appSettings[`AuditWithButtonAW1${num}`],
      silentClientRpt = !!appSettings[`AuditWithButtonAW2${num}`],
      silentXchng = !!appSettings[`AuditWithButtonAW3${num}`],
      silentPrintPp = !!appSettings[`AuditWithButtonPP${num}`],
      silentPrintIw = !!appSettings[`AuditWithButtonIW${num}`],
      silentPrintLw = !!appSettings[`AuditWithButtonLW${num}`],
      silentPrintTemplate = !!appSettings[`AuditWithButtonTemplate${num}`],
      silentPrintSwitch = !!appSettings[`AuditWithButtonSwitch${num}`],
      customSolution = appSettings[`PostbackSolution${num}`],
      newTab = appSettings[`RedirectSameTab${num}`] ? '_self' : '_blank';

    let externalModal;

    try {
      externalModal = JSON.parse(appSettings.ModalName);
    } catch (error) {
      console.error('Not valid json for modal: ', error);
    }

    if (externalModal && externalModal.ModalName.toLowerCase() === 'pershing') {
      let runModal = false;
      this.rbs.getPershingGroupProfile(this.profile).subscribe(res => {
        runModal = res.PershingModal.AskForRRCode;

        if (runModal) {
          this.unfFlowSvc.setLoading(false);
          let dialogRef = this.dialog.open(CustomReportModalComponent, {
            panelClass: 'warn-dialog',
            minWidth: '50vw',
            data: {
              profile: this.profile,
              name: externalModal.ModalName,
              headline: externalModal.Title,
              content: externalModal.Body,
              accounts: res.PershingModalAccountType,
              confirm: 'Submit',
            },
          });

          dialogRef.afterClosed().subscribe(result => {
            this.submitting = false;
            dialogRef = null;
            if (result !== 'cancel') {
              this.runSilentPrints({
                aw: silentPrintAw,
                temp: silentPrintTemplate,
                sw: silentPrintSwitch,
                awClient: silentClientRpt,
                exchange: silentXchng,
                pp: silentPrintPp,
                iw: silentPrintIw,
                lw: silentPrintLw,
              }).subscribe();

              let networkDialogRef = this.dialog.open(
                NetworkLoadingModalComponent,
                {
                  width: '50vw',
                  panelClass: 'network-loading-dialog',
                  data: {
                    headline: this.networkModalData.title,
                    body: this.networkModalData.body,
                    loadingMessages: this.networkModalData.messages,
                    messageDelay: this.networkModalData.messageDelay,
                  },
                  disableClose: true,
                }
              );
              this.rbs
                .extPostbackData(this.profile, null, customSolution)
                .subscribe({
                  next: x => {
                    networkDialogRef.componentInstance.networkResponseReceived = true;
                    networkDialogRef.close();
                    networkDialogRef.afterClosed().subscribe(() => {
                      networkDialogRef = null;
                    });
                    if (x && x.results && x.results.length > 0) {
                      const link = x.results;
                      window.open(link, newTab);
                    } else if (x && x.SAMLResponse) {
                      this.loginRedirect(x);
                    } else {
                      let dialogRef = this.dialog.open(WarnDialogComponent, {
                        panelClass: 'warn-dialog',
                        data: {
                          headline: 'Warning',
                          content:
                            'The service you are trying to connect to is not currently available. Please report this to your system administrator and try again later.',
                          confirm: 'OK',
                          hideCancel: true,
                        },
                      });
                      dialogRef.afterClosed().subscribe(() => {
                        this.submitting = false;
                        dialogRef = null;
                      });
                    }
                  },
                  error: err => {
                    networkDialogRef.componentInstance.networkResponseReceived = true;
                    networkDialogRef.close();
                    networkDialogRef.afterClosed().subscribe(() => {
                      networkDialogRef = null;
                    });
                    this.snacky.open(
                      'There was an error with this request.',
                      'Close',
                      {
                        duration: 10000,
                      }
                    );
                    throw new Error(err);
                  },
                });
            } else {
              this.unfFlowSvc.setLoading(false);
              console.warn('User opted out of submission');
            }
          });
        } else {
          let networkDialogRef = this.dialog.open(
            NetworkLoadingModalComponent,
            {
              width: '50vw',
              panelClass: 'network-loading-dialog',
              data: {
                headline: this.networkModalData.title,
                body: this.networkModalData.body,
                loadingMessages: this.networkModalData.messages,
                messageDelay: this.networkModalData.messageDelay,
              },
              disableClose: true,
            }
          );
          this.rbs
            .extPostbackData(this.profile, null, customSolution)
            .subscribe({
              next: x => {
                networkDialogRef.componentInstance.networkResponseReceived = true;
                networkDialogRef.close();
                networkDialogRef.afterClosed().subscribe(() => {
                  networkDialogRef = null;
                });
                if (x && x.results && x.results.length > 0) {
                  const link = x.results;

                  this.unfFlowSvc.setLoading(false);
                  window.open(link, newTab);
                } else if (x && x.SAMLResponse) {
                  this.loginRedirect(x);
                } else {
                  setTimeout(() => {
                    let dialogRef = this.dialog.open(WarnDialogComponent, {
                      panelClass: 'warn-dialog',
                      data: {
                        headline: 'Warning',
                        content:
                          'The service you are trying to connect to is not currently available. Please report this to your system administrator and try again later.',
                        confirm: 'OK',
                        hideCancel: true,
                      },
                    });
                    dialogRef.afterOpened().subscribe(() => {
                      this.unfFlowSvc.setLoading(false);
                    });
                    dialogRef.afterClosed().subscribe(() => {
                      this.submitting = false;
                      dialogRef = null;
                    });
                  });
                }
              },
              error: err => {
                networkDialogRef.componentInstance.networkResponseReceived = true;
                networkDialogRef.close();
                networkDialogRef.afterClosed().subscribe(() => {
                  networkDialogRef = null;
                });
                this.snacky.open(
                  'There was an error with this request.',
                  'Close',
                  {
                    duration: 10000,
                  }
                );
                throw new Error(err);
              },
            });
        }
      });
    } else if (
      externalModal &&
      externalModal.ModalName.toLowerCase() !== 'pershing'
    ) {
      let dialogRef = this.dialog.open(WarnDialogComponent, {
        panelClass: 'warn-dialog',
        data: {
          name: externalModal.ModalName,
          headline: externalModal.Title,
          content: externalModal.Body,
          confirm: 'Submit',
        },
      });

      dialogRef.afterClosed().subscribe(result => {
        this.submitting = false;
        dialogRef = null;
        if (result !== 'cancel') {
          this.runSilentPrints({
            aw: silentPrintAw,
            temp: silentPrintTemplate,
            sw: silentPrintSwitch,
            awClient: silentClientRpt,
            exchange: silentXchng,
            pp: silentPrintPp,
            iw: silentPrintIw,
            lw: silentPrintLw,
          }).subscribe();

          let networkDialogRef = this.dialog.open(
            NetworkLoadingModalComponent,
            {
              width: '50vw',
              panelClass: 'network-loading-dialog',
              data: {
                headline: this.networkModalData.title,
                body: this.networkModalData.body,
                loadingMessages: this.networkModalData.messages,
                messageDelay: this.networkModalData.messageDelay,
              },
              disableClose: true,
            }
          );
          this.rbs
            .extPostbackData(this.profile, result, customSolution)
            .subscribe({
              next: x => {
                networkDialogRef.componentInstance.networkResponseReceived = true;
                networkDialogRef.close();
                networkDialogRef.afterClosed().subscribe(() => {
                  networkDialogRef = null;
                });
                if (x && x.results && x.results.length > 0) {
                  const link = x.results;

                  this.unfFlowSvc.setLoading(false);
                  window.open(link, newTab);
                } else {
                  this.unfFlowSvc.setLoading(false);
                  let dialogRef = this.dialog.open(WarnDialogComponent, {
                    panelClass: 'warn-dialog',
                    data: {
                      headline: 'Warning',
                      content:
                        'The service you are trying to connect to is not currently available. Please report this to your system administrator and try again later.',
                      confirm: 'OK',
                      hideCancel: true,
                    },
                  });
                  dialogRef.afterClosed().subscribe(() => {
                    this.submitting = false;
                    dialogRef = null;
                  });
                }
              },
              error: err => {
                networkDialogRef.componentInstance.networkResponseReceived = true;
                networkDialogRef.close();
                networkDialogRef.afterClosed().subscribe(() => {
                  networkDialogRef = null;
                });
                this.snacky.open(
                  'There was an error with this request.',
                  'Close',
                  {
                    duration: 10000,
                  }
                );
                throw new Error(err);
              },
            });
        } else {
          this.unfFlowSvc.setLoading(false);
          console.warn('User opted out of submission');
        }
      });
    } else if (this.existingOrderId && !ignoreWarning) {
      const dialogRef = this.dialog.open(WarnDialogComponent, {
        panelClass: 'warn-dialog',
        data: {
          headline: 'Warning',
          content:
            'This case has been submitted to order entry. If sent again, it will create a new record in the order entry system.',
          confirm: 'OK',
          hideCancel: false,
        },
      });
      dialogRef.afterClosed().subscribe(result => {
        this.submitting = false;
        if (result === 'continue') {
          this.postback(app, appSettings, buttonNum, true);
        } else {
          this.unfFlowSvc.setLoading(false);
        }
      });
    } else {
      if (
        this.buttons.postBackModalName &&
        this.buttons.postBackModalName.length > 0
      ) {
        let dialogRef = this.dialog.open(ConsolidatedReportModalComponent, {
          panelClass: 'consolidated-report',
          data: { profile: this.profile, silentPrint: true },
          minWidth: '80vw',
          minHeight: '95vh',
          maxHeight: '95vh',
        });

        dialogRef.afterClosed().subscribe(result => {
          this.runSilentPrints({
            aw: silentPrintAw,
            temp: silentPrintTemplate,
            sw: silentPrintSwitch,
            awClient: silentClientRpt,
            exchange: silentXchng,
            pp: silentPrintPp,
            iw: silentPrintIw,
            lw: silentPrintLw,
          }).subscribe();

          this.submitting = false;
          dialogRef = null;
          let networkDialogRef = this.dialog.open(
            NetworkLoadingModalComponent,
            {
              width: '50vw',
              panelClass: 'network-loading-dialog',
              data: {
                headline: this.networkModalData.title,
                body: this.networkModalData.body,
                loadingMessages: this.networkModalData.messages,
                messageDelay: this.networkModalData.messageDelay,
              },
              disableClose: true,
            }
          );
          this.rbs
            .extPostbackData(this.profile, result, customSolution)
            .subscribe({
              next: x => {
                networkDialogRef.componentInstance.networkResponseReceived = true;
                networkDialogRef.close();
                networkDialogRef.afterClosed().subscribe(() => {
                  networkDialogRef = null;
                });
                if (x && x.results) {
                  const link = x.results;

                  this.unfFlowSvc.setLoading(false);
                  window.open(link, newTab);
                } else if (x && (x.url || x.token)) {
                  this.loginRedirect(x);
                } else {
                  const message = x.errorMessage
                    ? x.errorMessage
                    : 'The service you are trying to connect to is not currently available. Please report this to your system administrator and try again later.';
                  let dialogRef = this.dialog.open(WarnDialogComponent, {
                    panelClass: 'warn-dialog',
                    data: {
                      headline: 'Warning',
                      content: message,
                      confirm: 'OK',
                      hideCancel: true,
                    },
                  });
                  dialogRef.afterClosed().subscribe(() => {
                    this.submitting = false;
                    dialogRef = null;

                    this.unfFlowSvc.setLoading(false);
                  });
                }
              },
              error: err => {
                networkDialogRef.componentInstance.networkResponseReceived = true;
                networkDialogRef.close();
                networkDialogRef.afterClosed().subscribe(() => {
                  networkDialogRef = null;
                });
                this.snacky.open(
                  'There was an error with this request.',
                  'Close',
                  {
                    duration: 10000,
                  }
                );
                throw new Error(err);
              },
            });
        });
      } else if (
        !this.existingOrderId ||
        (this.existingOrderId && ignoreWarning)
      ) {
        this.runSilentPrints({
          aw: silentPrintAw,
          temp: silentPrintTemplate,
          sw: silentPrintSwitch,
          awClient: silentClientRpt,
          exchange: silentXchng,
          pp: silentPrintPp,
          iw: silentPrintIw,
          lw: silentPrintLw,
        }).subscribe();

        let networkDialogRef = this.dialog.open(NetworkLoadingModalComponent, {
          width: '50vw',
          panelClass: 'network-loading-dialog',
          data: {
            headline: this.networkModalData.title,
            body: this.networkModalData.body,
            loadingMessages: this.networkModalData.messages,
            messageDelay: this.networkModalData.messageDelay,
          },
          disableClose: true,
        });
        this.rbs.extPostback(this.profile, customSolution).subscribe({
          next: x => {
            networkDialogRef.componentInstance.networkResponseReceived = true;
            networkDialogRef.close();
            networkDialogRef.afterClosed().subscribe(() => {
              networkDialogRef = null;
            });
            if (x && x.results) {
              const link = x.results;
              const outsideLink = link.includes('http');

              if (outsideLink) {
                window.open(link, newTab);
              } else {
                this.router.navigateByUrl(link);
              }
            } else if (x && !x.results && (x.url || x.token)) {
              this.loginRedirect(x);
            } else {
              const message =
                x && x.errorMessage
                  ? x.errorMessage
                  : 'The service you are trying to connect to is not currently available. Please report this to your system administrator and try again later.';

              this.unfFlowSvc.setLoading(false);
              let dialogRef = this.dialog.open(WarnDialogComponent, {
                panelClass: 'warn-dialog',
                data: {
                  headline: 'Warning',
                  content: message,
                  confirm: 'OK',
                  hideCancel: true,
                },
              });
              dialogRef.afterClosed().subscribe(() => {
                this.submitting = false;
                dialogRef = null;
              });
            }
          },
          error: err => {
            networkDialogRef.componentInstance.networkResponseReceived = true;
            networkDialogRef.close();
            networkDialogRef.afterClosed().subscribe(() => {
              networkDialogRef = null;
            });
            this.snacky.open('There was an error with this request.', 'Close', {
              duration: 10000,
            });
            throw new Error(err);
          },
        });
      }
    }
  }

  standardPostback(app, appSettings?, buttonNum?) {
    const num = buttonNum ? buttonNum : '',
      silentPrintAw =
        app === 'aw'
          ? !!appSettings[`AuditWithButtonAW1${num}`]
          : !!appSettings[`AuditWithButton${app.toUpperCase()}`],
      silentClientRpt = !!appSettings[`AuditWithButtonAW2${num}`],
      silentXchng = !!appSettings[`AuditWithButtonAW3${num}`],
      silentPrintPp = !!appSettings[`AuditWithButtonPP${num}`],
      silentPrintIw = !!appSettings[`AuditWithButtonIW${num}`],
      silentPrintLw = !!appSettings[`AuditWithButtonLW${num}`],
      silentPrintTemplate = !!appSettings[`AuditWithButtonTemplate${num}`],
      silentPrintSwitch = !!appSettings[`AuditWithButtonSwitch${num}`],
      newTab = appSettings[`RedirectSameTab${num}`] ? '_self' : 'new',
      includePID = appSettings[`IncludePID${num}`];

    this.unfFlowSvc.setLoading(true);

    try {
      JSON.parse(this.buttons.ModalName);
    } catch (error) {
      console.error('Not valid json for modal: ', error);
    }
    this.runSilentPrints({
      aw: silentPrintAw,
      temp: silentPrintTemplate,
      sw: silentPrintSwitch,
      awClient: silentClientRpt,
      exchange: silentXchng,
      pp: silentPrintPp,
      iw: silentPrintIw,
      lw: silentPrintLw,
    }).subscribe();

    let link = this.buttons.RedirectURL || null;
    const outsideLink = link.includes('http');

    if (includePID) {
      link += this.profile;
    }

    this.rbs.postback(this.profile).subscribe(() => {
      if (outsideLink) {
        window.open(link, newTab);
      } else {
        this.router.navigateByUrl(link);
      }
    });
  }

  runSilentPrints(reports): Observable<any> {
    const reportObservables: Observable<any>[] = [];

    Object.keys(reports).forEach(el => {
      const type = el;
      let app = el;
      if (reports[el]) {
        if (el === 'awClient' || el === 'exchange') {
          app = 'aw';
          reportObservables.push(this.getSilentReport(app, type));
        } else if (el === 'sw') {
          app = 'pp';
          reportObservables.push(this.getSilentCustomReport('switch'));
        } else if (el === 'temp') {
          reportObservables.push(this.getSilentCustomReport('template'));
        } else {
          reportObservables.push(this.getSilentReport(app, type));
        }
      }
    });

    // If no reports to run, return a completed observable
    return reportObservables.length > 0
      ? forkJoin(reportObservables)
      : of(null);
  }

  private getSilentReport(app: string, type?: string): Observable<any> {
    // Call getReport with silent=true to prevent PDF generation, return the observable
    return new Observable(observer => {
      this.getReport(null, app, type, true);
      // Since getReport handles its own subscription, we complete immediately
      observer.next(null);
      observer.complete();
    });
  }

  private getSilentCustomReport(reportType: string): Observable<any> {
    // Call customReport with silent=true to prevent PDF generation, return the observable
    return new Observable(observer => {
      this.customReport(reportType, true);
      // Since customReport handles its own subscription, we complete immediately
      observer.next(null);
      observer.complete();
    });
  }

  setSummaryClient(Client) {
    this.summaryClient.emit({ Client });
  }

  copyCase() {
    this.unfFlowSvc.copyCaseId.set(this.profile);
    const copyCaseDialogRef = this.dialog.open(CopyCaseModalComponent, {
      panelClass: 'copy-case-dialog',
      width: '98vw',
      autoFocus: false,
    });

    copyCaseDialogRef.afterClosed().subscribe(resp => {
      if (resp.data && resp.data !== 'cancel') {
        this.unfFlowSvc.copyCaseData.set(resp.data);

        this.modStatusSvc.apps.set(['rb']);
        this.ss.set('currentApp', 'rb');
        this.rbs.setApp('rb');

        this.rbs
          .newProfile({ 'Profile.Description': '' }, true)
          .subscribe(x => {
            if (!this.rights?.includes('ReadOnly')) {
              this.router.navigate([`/case/rb/${x.results}/0`]);
            } else {
              this.rbs.getQuestions(x.results).subscribe(data => {
                const profile = this.getUniqueId(3);
                this.ss.set('noSave', {
                  id: profile,
                  profile: null,
                  questionnaire: data.results.questionnaire,
                });

                this.router.navigate([`/case/rb/${profile}/0`]);
              });
            }
          });
      }
    });
  }

  getUniqueId(parts: number): string {
    const stringArr = [];
    for (let i = 0; i < parts; i++) {
      // tslint:disable-next-line:no-bitwise
      const S4 = (((1 + Math.random()) * 0x10000) | 0)
        .toString(16)
        .substring(1);
      stringArr.push(S4);
    }
    return stringArr.join('-');
  }

  jpmcDataCall() {
    this.rbs.getGroupProfile(this.profile, 'JPMCOrder', 'iw').subscribe(res => {
      const dataOut = encodeURIComponent(JSON.stringify(res));
      const id = res.traceid as number;
      callGlue(dataOut, id);
    });
  }

  parseInstructionText(instructionData: string): string {
    const isValidJson = (str: string): boolean => {
      try {
        JSON.parse(str);
        return true;
      } catch {
        return false;
      }
    };

    if (typeof instructionData === 'string' && isValidJson(instructionData)) {
      const jsonData = JSON.parse(instructionData);

      if (
        jsonData &&
        typeof jsonData === 'object' &&
        typeof jsonData.submittedBy === 'string' &&
        typeof jsonData.submitDate === 'string' &&
        !isNaN(Date.parse(jsonData.submitDate))
      ) {
        return `Submitted by: ${jsonData.submittedBy} on ${new Date(
          jsonData.submitDate
        ).toLocaleString('en-US')}`;
      } else if (jsonData && typeof jsonData === 'object') {
        // not in predetermined format of first if. printing values.
        return Object.values(jsonData)
          .map(value => (value !== null ? String(value) : ''))
          .join(' ');
      }
    }

    return instructionData;
  }

  summaryCheck(ev: boolean) {
    this.aiSummaryCheckedVar = ev;
    this.aiSummaryChecked.emit(ev);
  }

  summaryTextChange(ev): void {
    this.aiSummaryText = ev;
  }

  saveSummary(ev?) {
    if (ev) {
      this.aiSummaryText = ev;
    }
    this.postTradeService
      .patchAiSummary({
        text: this.aiSummaryText,
        referenceId: this.profile,
        type: 'aicasereview_edited',
      })
      .subscribe();
  }
}
